import { observer } from 'mobx-react-lite';
import { usePendingBookings } from '@/hooks/usePendingBookings';
import { PendingBookingsListModal } from '@/components/PendingBookingsListModal';

/**
 * Глобальный список новых записей (pending_confirmation).
 * Показывает все записи, ожидающие подтверждения, сразу одним списком — подтвердить
 * или отменить любую из них можно на месте, не открывая модалку заново для каждой.
 */
export const PendingBookingsChecker = observer(() => {
  const { isModalOpen, closeModal, confirmBooking, cancelBooking } = usePendingBookings();

  return (
    <PendingBookingsListModal
      isOpen={isModalOpen}
      onClose={closeModal}
      onConfirm={confirmBooking}
      onCancel={cancelBooking}
    />
  );
});

PendingBookingsChecker.displayName = 'PendingBookingsChecker';
